
import React from "react";
import Navbar from "@/components/Navbar";
import New2Hero from "@/components/new2/New2Hero";
import New2Benefits from "@/components/new2/New2Benefits";
import New2HowItWorks from "@/components/new2/New2HowItWorks";
import New2Pricing from "@/components/new2/New2Pricing";
import New2Testimonials from "@/components/new2/New2Testimonials";
import New2FAQ from "@/components/new2/New2FAQ";
import New2Security from "@/components/new2/New2Security";
import New2Calculator from "@/components/new2/New2Calculator";
import New2FinalCTA from "@/components/new2/New2FinalCTA";
import Footer from "@/components/Footer";

const New2Landing = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar activePage="new2" />
      <New2Hero />
      <New2Benefits />
      <New2HowItWorks />
      <New2Calculator />
      <New2Pricing />
      <New2Testimonials />
      <New2Security />
      <New2FAQ />
      <New2FinalCTA />
      <Footer />
    </div>
  );
};

export default New2Landing;
